exports.components = {
  "component---src-components-job-post-tsx": () => import("./../../../src/components/JobPost.tsx" /* webpackChunkName: "component---src-components-job-post-tsx" */),
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */)
}

